import "./KorisnikHomePage.css";
import Background from "../../components/Background4";
import letak from "../../img/letak.jpg";
import usavrsavanje from "../../img/usavrsavanje.jpg";
import postignuca from "../../img/postignuca.jpg";
import tim from "../../img/tim.jpg";
import React, { useState, useEffect, useRef } from "react";

const KorisnikHomePage = () => {
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [animatedSections, setAnimatedSections] = useState(new Set());

  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const visionRef = useRef(null);
  const teamRef = useRef(null);
  const achievementsRef = useRef(null);
  const testimonialsRef = useRef(null);

  const testimonials = [
    {
      text: "Ovaj proces bih opisala kao nešto drugačije što sam do sada iskusila. Bilo je izazovno, ali i poučno.",
    },
    {
      text: "Bilo je predivno i vrlo korisno iskustvo, koje mi je dosta olakšalo dalje životno putovanje.",
    },
    {
      text: "Moji utisi o cjelokupnom procesu su zaista pozitvni. Radila sam sa odličnom terapeutkinjom koja je prepoznala moje potrebe i pomogla mi da riješim tegobe povodom kojih sam se prijavila. Takođe, sam prostor u kome se terapije odvijaju je vrlo prijatan.",
    },
    {
      text: "Na terapiji sam se osjećala uvijek saslušano, bilo je i težih trenutaka i srećnijih, ali ukupan zaključak je da mi je donijelo dosta spoznaje o sebi i dalo mi hrabrosti da stanem iza sebe i sačuvam se.",
    },
    {
      text: "Terapija je bila veoma produktivna i nevjerovatno mi je drago što sam imala priliku za tako nešto, iako je moj prvobitni stav bio kako sam ja tu turistički, pomogla mi je da shvatim mnogo toga i da riješim probleme koje nisam ni znala da imam.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setAnimatedSections((prev) => new Set(prev).add(entry.target));
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const refs = [
      heroRef.current,
      aboutRef.current,
      visionRef.current,
      teamRef.current,
      achievementsRef.current,
      testimonialsRef.current,
    ].filter(Boolean);

    refs.forEach((section) => observer.observe(section));

    return () => {
      refs.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div className="korisnikhomepage-div">
      <Background className="background" />
      <div className="korisnikhomepage-container">
        <section
          ref={heroRef}
          className={`hero-section ${
            animatedSections.has(heroRef.current) ? "animate" : ""
          }`}
        >
          <div className="hero-content">
            <h1 className="hero-content h1">
              Psihološko savjetovalište za studente UNIBL
            </h1>
            <p className="hero-content p">
              Pružamo stručnu podršku i savjetovanje svim studentima koji žele
              da rade na sebi, da se osnaže i nauče nešto više o mentalnom
              zdravlju.
            </p>
          </div>
        </section>

        <section
          ref={aboutRef}
          className={`content-section ${
            animatedSections.has(aboutRef.current) ? "animate" : ""
          }`}
        >
          <div className="section-container">
            <h2 className="section-title">O nama</h2>
            <p className="section-subtitle">
              Djelujemo kao podorganizaciona jedinica Filozofskog fakulteta
              Univerziteta u Banjoj Luci i osnovani smo 2022. godine. Pružamo
              usluge savjetovanja i psihoterapije – online ili uživo, modalitet
              birate vi i organizujemo radionice na teme mentalnog zdravlja koje
              predlažu upravo studenti.
            </p>
            <div className="cards-container">
              <div className="card">
                <img src={letak} alt="Savjetovalište" className="card-image" />
                <div className="card-content">
                  <h3>Naša misija</h3>
                  <p>
                    Pružamo usluge savjetovanja i psihoterapije – online ili
                    uživo, modalitet birate vi. Organizujemo radionice na teme
                    mentalnog zdravlja koje predlažu upravo studenti.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          ref={visionRef}
          className={`content-section content-section-alt ${
            animatedSections.has(visionRef.current) ? "animate" : ""
          }`}
        >
          <div className="section-container">
            <h2 className="section-title">Naša vizija</h2>
            <div className="cards-container">
              <div className="card">
                <div className="card-content">
                  <h3>Tvoja podrška tokom studija</h3>
                  <p>
                    Naša vizija je da mentalno zdravlje studenata postane
                    prioritet i da stručna pomoć i podrška bude dostupna svakome
                    kome je potrebna.
                  </p>
                  <ul>
                    <li>
                      Pružanje savjetodavne i psihoterapijske podrške studentima
                      koji imaju poteškoće u prilagođavanju na studentski život
                    </li>
                    <li>Aktivna promocija mentalnog zdravlja u zajednici</li>
                    <li>Unapređenje dobrobiti studentske populacije</li>
                  </ul>
                </div>
                <img src={usavrsavanje} alt="Vizija" className="card-image" />
              </div>
            </div>
          </div>
        </section>

        <section
          ref={teamRef}
          className={`content-section ${
            animatedSections.has(teamRef.current) ? "animate" : ""
          }`}
        >
          <div className="section-container">
            <h2 className="section-title">Naš tim</h2>
            <p className="section-subtitle">
              Naše Savjetovalište okuplja eklektičan tim stručnjaka i volontera
              posvećenih mentalnom zdravlju mladih. Naš tim čine: koordinator,
              administrativni tim, volonteri psihoterapeuti (u edukaciji i pod
              supervizijom ili sa završenom edukacijom) i supervizori.
            </p>
            <div className="team-grid">
              <div className="team-member">
                <img src={tim} alt="Tim" />
                <h4>Stručni tim</h4>
                <p>
                  Pod jednim krovom okupljamo više od 20 vrijednih i predanih
                  volontera i čak 7 psihoterapijskih škola: transakciona
                  analiza, sistemska porodična, kognitivno-bihevioralna,
                  integrativna za odrasle, dječija i adolescentna integrativna,
                  realitetna terapija i tjelesna psihoterapija.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section
          ref={achievementsRef}
          className={`content-section content-section-alt ${
            animatedSections.has(achievementsRef.current) ? "animate" : ""
          }`}
        >
          <div className="section-container">
            <h2 className="section-title">Šta smo postigli do sada?</h2>
            <div className="cards-container">
              <div className="card">
                <div className="card-content">
                  <ul>
                    <li>
                      Održali više od 1500 psihoterapijskih seansi i preko 200
                      trijažnih seansi, te u sam psihoterapijski proces
                      uključili više od 180 studenata i studentkinja
                    </li>
                    <li>
                      Održali više od 15 radionica i mnogobrojna predavanja na
                      različite teme iz oblasti mentalnog zdravlja
                    </li>
                    <li>
                      Uključili studente psihologije kroz volonterski angažman
                    </li>
                    <li>Aktivno učestvovali u promociji mentalnog zdravlja</li>
                  </ul>
                </div>
                <img src={postignuca} alt="Postignuća" className="card-image" />
              </div>
            </div>
          </div>
        </section>

        <section
          ref={testimonialsRef}
          className={`testimonials-carousel-section ${
            animatedSections.has(testimonialsRef.current) ? "animate" : ""
          }`}
        >
          <h2 className="testimonials-carousel-title">Utisci klijenata</h2>
          <div className="testimonial-carousel-content">
            <span className="testimonial-quote-mark">“</span>
            <p className="testimonial-carousel-text">
              {testimonials[testimonialIndex].text}
            </p>
            <span className="testimonial-quote-mark end">”</span>
            <div className="testimonial-carousel-author">
              {testimonials[testimonialIndex].author}
            </div>
            <div className="testimonial-carousel-dots">
              {testimonials.map((_, idx) => (
                <span
                  key={idx}
                  className={`testimonial-dot ${
                    testimonialIndex === idx ? "active" : ""
                  }`}
                  onClick={() => setTestimonialIndex(idx)}
                  role="button"
                  aria-label={`Select testimonial ${idx + 1}`}
                  tabIndex={0}
                />
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default KorisnikHomePage;
